<script>
import { defineComponent, h, inject } from 'vue'

import { isAzureAppInjectionKey } from '@/utils/injection-keys'

import AppIcon from '@/components/ui/AppIcon/AppIcon'

export default defineComponent({
  name: 'SyncedGroupIcon',

  setup() {
    const isAzureApp = inject(isAzureAppInjectionKey)

    return () => {
      return h(AppIcon, {
        iconName: isAzureApp ? 'replace_azure-large' : 'replace_jira-large',
        height: 24,
        width: 24
      })
    }
  }
})
</script>
